export default __webpack_public_path__ + "static/media/startime.8ad5ff37.svg";